"use strict";

var _interopRequireDefault = require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
var _regenerator2 = _interopRequireDefault(require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _data = require("@/api/data");
var _default = exports.default = {
  data: function data() {
    return {
      loading: true,
      data: [],
      page: 1,
      size: 10,
      total: 0,
      url: '',
      params: {},
      query: {},
      time: 170,
      isAdd: true,
      multipleSelection: [],
      resdatas: null
    };
  },
  methods: {
    init: function init() {
      var _this = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.beforeInit();
            case 1:
              if (_context.v) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              return _context.a(2, new Promise(function (resolve, reject) {
                _this.loading = true;
                (0, _data.initData)(_this.url, _this.params).then(function (res) {
                  _this.total = res.data.page.count;
                  _this.data = res.data.page.data;
                  _this.resdatas = res.data;
                  //  console.info(this.data)
                  setTimeout(function () {
                    _this.loading = false;
                  }, _this.time);
                  resolve(res);
                }).catch(function (err) {
                  _this.loading = false;
                  reject(err);
                });
              }));
          }
        }, _callee);
      }))();
    },
    beforeInit: function beforeInit() {
      return true;
    },
    pageChange: function pageChange(e) {
      this.page = e;
      this.init();
    },
    sizeChange: function sizeChange(e) {
      this.page = 1;
      this.size = e;
      this.init();
    },
    // 预防删除第二页最后一条数据时，或者多选删除第二页的数据时，页码错误导致请求无数据
    dleChangePage: function dleChangePage(size) {
      if (size === undefined) {
        size = 1;
      }
      if (this.data.length === size && this.page !== 0) {
        this.page = this.page - 1;
      }
    },
    /**
     * 搜索条件重置
     */
    toReSet: function toReSet() {
      this.query = {};
    },
    // 去查询
    toQuery: function toQuery() {
      this.page = 1;
      this.init();
    },
    /**
     * 展开、折叠 树形表格使用
     */
    expandAll: function expandAll() {
      this.expand = !this.expand;
      this.init();
    }
  }
};